import {Directive, Input} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {isNullOrUndefined} from "util";
import {ControlAccessors, InputModifierService} from "./input-modifier.service";

@Directive({
    selector: '[formGroup][controlName][removeWhiteSpaces]',
    host: {
        '(input)': 'onInput($event)',
    }
})
export class WhitespacesRemoveDirective {

    @Input('controlName') controlName: string;
    @Input('formGroup') form: FormGroup;

    constructor(private _inputModifier: InputModifierService) {
    }

    onInput(event) {
        this._inputModifier.transformControlValue<string>(ControlAccessors.forReactiveForm(this.form, this.controlName),
            event, this.transform)
    }

    transform(value: string): string {
        if(!value) {
            return null;
        }
        return value.replace(/\s+/g, '').trim();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/input-modifiers/whitespaces-remove.directive.ts